import React from "react";
import { useTranslation } from "react-i18next";
import { FaQuoteLeft } from "react-icons/fa";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const SectionLeft = ({ title, onPrev, onNext, progress }) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  return (
    <div className="flex h-full flex-col items-center justify-center text-center lg:items-start lg:text-start">
      <FaQuoteLeft className="text-primary text-3xl sm:text-4xl lg:text-5xl" />

      <h2 className="text-dark mt-4 text-2xl leading-snug font-semibold sm:mt-6 sm:text-3xl">
        {title}
      </h2>

      {/* controls row */}
      <div className="mt-6 flex w-full max-w-md items-center gap-3 sm:mt-8 sm:gap-4">
        {/* PREV */}
        <button
          onClick={onPrev}
          aria-label={isRTL ? "Next slide" : "Previous slide"}
          className="flex size-10 cursor-pointer items-center justify-center rounded-full border transition hover:bg-gray-100 sm:h-12 sm:w-12"
        >
          {isRTL ? <FaArrowRight /> : <FaArrowLeft />}
        </button>

        {/* PROGRESS */}
        <div className="relative h-[4px] flex-1 overflow-hidden rounded-full bg-gray-200">
          <div
            className="bg-primary h-full transition-all duration-500"
            style={{ width: `${progress}%` }}
          />
        </div>

        {/* NEXT */}
        <button
          onClick={onNext}
          aria-label={isRTL ? "Previous slide" : "Next slide"}
          className="flex size-10 cursor-pointer items-center justify-center rounded-full border transition hover:bg-gray-100 sm:h-12 sm:w-12"
        >
          {isRTL ? <FaArrowLeft /> : <FaArrowRight />}
        </button>
      </div>
    </div>
  );
};

export default SectionLeft;
